<div class="map-container">
	<div id="map"></div>

	<div [class.map-overlay--active]="activeOffer" class="map-overlay">
		@if (activeOffer) {
			<ivva-offer-card [lowerLabel]="true" [offer]="activeOffer"></ivva-offer-card>
		}

		<button (click)="close()" class="c-close-btn">
			<tvcore-icon name="close"></tvcore-icon>
		</button>
	</div>
</div>

<!--<div class="card-container">-->
<!--	<div class="card-list">-->
<!--		@for (item of items; track item.offer.id) {-->
<!--			<div (click)="activate(item)" [class.card&#45;&#45;active]="isActive(item)" class="card">-->
<!--				<p class="u-title-group">{{ item.offer.name }}</p>-->
<!--			</div>-->
<!--		}-->
<!--	</div>-->
<!--</div>-->
